module.exports = __webpack_public_path__ + "img/BatteryCharging20Filled.b4c4d0d0.svg";